/**
 * Applies the bundle discount code when the cart has enough bundle-tagged items.
 */
(function () {
  const DEFAULT_MIN_ITEMS = 2;

  function getConfig() {
    return window.Theme?.bundleDiscount || {};
  }

  function getCartUpdateUrl() {
    return window.Theme?.routes?.cart_update_url || '/cart/update';
  }

  function getCartSectionIds() {
    const ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (item) {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        ids.push(item.dataset.sectionId);
      }
    });
    return ids;
  }

  function countBundleItems(cart) {
    let count = 0;
    (cart.items || []).forEach(function (item) {
      const props = item.properties || {};
      if (props._bundle === 'true' || props._bundle === true) {
        count += 1;
      }
    });
    return count;
  }

  function getExistingDiscountCodes(cart) {
    const codes = [];
    (cart.cart_level_discount_applications || []).forEach(function (application) {
      if (application.type === 'discount_code' && application.title) {
        codes.push(application.title);
      }
    });
    return codes;
  }

  function cartHasDiscount(cart) {
    return (cart.cart_level_discount_applications || []).length > 0;
  }

  function applyIfNeeded(sectionIds) {
    const config = getConfig();
    const discountCode = (config.discountCode || '').trim();
    const minItems = Number(config.minItems) || DEFAULT_MIN_ITEMS;

    if (!discountCode) {
      return Promise.resolve(null);
    }

    const ids = sectionIds && sectionIds.length ? sectionIds : getCartSectionIds();

    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (countBundleItems(cart) < minItems) {
          return { cart: cart, sections: null, alreadyApplied: true };
        }

        if (cartHasDiscount(cart)) {
          return { cart: cart, sections: null, alreadyApplied: true };
        }

        const existingCodes = getExistingDiscountCodes(cart);
        if (existingCodes.indexOf(discountCode) !== -1) {
          return { cart: cart, sections: null, alreadyApplied: true };
        }

        const payload = {
          discount: existingCodes.concat(discountCode).join(','),
        };

        if (ids.length) {
          payload.sections = ids.join(',');
          payload.sections_url = window.location.pathname;
        }

        return fetch(getCartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(payload),
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (updateData) {
            const applicable = (updateData.discount_codes || []).find(function (entry) {
              return entry.code === discountCode && entry.applicable === true;
            });

            if (!applicable) {
              return { cart: cart, sections: null, alreadyApplied: true };
            }

            return fetch('/cart.js')
              .then(function (response) {
                return response.json();
              })
              .then(function (updatedCart) {
                return {
                  cart: updatedCart,
                  sections: updateData.sections || null,
                  alreadyApplied: false,
                };
              });
          });
      });
  }

  let pendingApply = false;

  function tryApplyFromCartEvent(event) {
    const config = getConfig();
    if (!(config.discountCode || '').trim()) return;
    if (pendingApply) return;

    const source = event?.detail?.data?.source;
    if (source === 'cart-bundle-discount') return;

    pendingApply = true;

    applyIfNeeded(getCartSectionIds())
      .then(function (result) {
        if (!result || result.alreadyApplied || !result.sections) return;

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: result.cart,
              sourceId: 'cart-bundle-discount',
              data: {
                source: 'cart-bundle-discount',
                itemCount: result.cart.item_count,
                sections: result.sections,
              },
            },
          })
        );
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        pendingApply = false;
      });
  }

  window.CartBundleDiscount = {
    applyIfNeeded: applyIfNeeded,
  };

  document.addEventListener('cart:update', tryApplyFromCartEvent);
})();
